import { useEffect } from "react";
import X from "lucide-react/dist/esm/icons/x";

interface RulesSheetProps {
  open: boolean;
  hapticsEnabled: boolean;
  onToggleHaptics: () => void;
  onClose: () => void;
}

export function RulesSheet({ open, hapticsEnabled, onToggleHaptics, onClose }: RulesSheetProps) {
  useEffect(function manageRulesSheet() {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function closeOnEscape(event: KeyboardEvent) {
      if (event.key === "Escape") onClose();
    }
    window.addEventListener("keydown", closeOnEscape);
    return function restorePage() {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sheet-backdrop" role="presentation" onPointerDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="rules-sheet" role="dialog" aria-modal="true" aria-labelledby="rules-title">
        <header>
          <div>
            <span className="eyebrow">CHIN · POKER52</span>
            <h2 id="rules-title">Cómo se juega</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Cerrar reglas" autoFocus>
            <X aria-hidden="true" size={22} />
          </button>
        </header>

        <ol className="rule-list">
          <li>
            <b>Jugá consecutivas</b>
            <p>Arrastrá una carta hasta el centro si es inmediatamente mayor o menor. El palo no importa.</p>
          </li>
          <li>
            <b>La escalera es circular</b>
            <p>A–2–3…J–Q–K–A. Podés poner un as sobre un rey y un rey sobre un as.</p>
          </li>
          <li>
            <b>Vaciá tu lado</b>
            <p>Cada hueco se repone desde tu mazo. Ganás cuando no te queda ninguna carta visible ni en reserva.</p>
          </li>
          <li>
            <b>Cantá CHIN</b>
            <p>Cuando las dos cartas superiores coinciden, tocá CHIN primero. El rival levanta ambos pozos. Si cantás mal, los levantás vos.</p>
          </li>
        </ol>

        <div className="rules-note">
          <strong>Sin jugadas</strong>
          <p>El servidor detecta el bloqueo y da vuelta cartas nuevas automáticamente.</p>
        </div>

        <label className="setting-row">
          <span>
            <strong>Vibración táctil</strong>
            <small>Una señal breve al jugar y cantar.</small>
          </span>
          <input type="checkbox" checked={hapticsEnabled} onChange={onToggleHaptics} />
          <i aria-hidden="true" />
        </label>

        <button className="primary-button" type="button" onClick={onClose}>Entendido</button>
      </section>
    </div>
  );
}
